import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { FormContainer, formHelper } from 'dood-react-components';

import NewsForm from '../../components/Form/NewsForm';

import { createLoadingSelector, translator } from '../../helpers';
import { newsActions, fileActions } from '../../actions';
import { loadingConstants } from '../../constants/loading.constants';
import { LANGUAGE_EN } from '../../constants/languages.constants';
import { newsConstants } from '../../constants/news.constants';

class Form extends Component {
    static fields = [
        'title',
        'description',
        'metaTitle',
        'metaDescription',
        'slug',
        'language',
        'fileId'
    ];

    constructor(props) {
        super(props);

        this.state = {
            news: formHelper.createStateFromFields(Form.fields, {
                language: LANGUAGE_EN
            }),
            error: ''
        };
    }

    componentDidMount() {
        if (this.props.isEdit) {
            this.props.find(this.props.match.params.id).then(
                response => {
                    const news = formHelper.mapValuesToFields(response, Form.fields);

                    this.setState({ news });
                }
            );
        }
    }

    handleSubmit = () => {
        const { news } = this.state;

        let data = {};

        Form.fields.forEach(field => {
            data[field] = news[field].value;

            // clear form errors
            delete news[field].errors;
        });

        this.setState({ news }, () => {
            this.props.isEdit
                ? this.handleEdit(data)
                : this.handleCreate(data);
        });
    };

    handleCreate = data => {
        this.props.create(data).then(
            () => {
                this.props.history.push('/news');
            },
            errors => {
                this.handleErrors(errors);
            }
        );
    };

    handleEdit = data => {
        this.props.edit(this.props.match.params.id, data).then(
            () => {
                this.props.history.push('/news');
            },
            errors => {
                this.handleErrors(errors);
            }
        );
    };

    handleCancel = () => {
        this.props.history.push('/news');
    };

    handleInputChange = changedFields => {
        this.setState(prevState => ({
            ...prevState,
            news: {
                ...prevState.news,
                ...changedFields
            }
        }));
    };

    handleErrors = errors => {
        const { news } = this.state;

        const { error, object } = formHelper.mapErrorsToFields(news, errors);

        this.setState({ news: object, error });
    };

    render() {
        const columnLayout = {
            xs: { span: 24 },
            sm: { span: 24 },
            md: { span: 24 }
        };

        const formComponent = (
            <NewsForm
                isEdit={this.props.isEdit}
                translate={this.props.translate}
                news={this.state.news}
                onInputChange={this.handleInputChange}
                onSubmit={this.handleSubmit}
                onCancel={this.handleCancel}
                upload={this.props.upload}
                error={this.state.error}
                fields={Form.fields}
            />
        );

        return (
            <FormContainer
                title={this.props.translate(this.props.isEdit ? 'title.edit_news' : 'title.create_news')}
                loading={this.props.loading}
                formComponent={formComponent}
                columnLayout={columnLayout}
            />
        );
    }
}

Form.propTypes = {
    isEdit: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
    return {
        translate: translator(state),
        loading: createLoadingSelector([
            loadingConstants.NEWS_CREATE,
            loadingConstants.NEWS_EDIT,
            loadingConstants.NEWS_FIND
        ])(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        find: id => dispatch(newsActions.find(id)),
        create: news => dispatch(newsActions.create(news)),
        edit: (id, news) => dispatch(newsActions.edit(id, news)),
        upload: file => dispatch(fileActions.upload(file, newsConstants.UPLOAD_PATH))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
